import { HttpService } from './HttpService';

export class KMSHttpService extends HttpService {
}

export default new KMSHttpService();
